import React from "react";

export function PageHeader({ title, subtitle, action, children }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6">
      <div>
        <h1 className="font-display text-2xl md:text-3xl font-bold tracking-tight text-[#09090B] leading-none">{title}</h1>
        {subtitle && <p className="text-sm text-zinc-500 mt-2">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{action || children}</div>
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div className={`bg-white border border-[#E4E4E7] rounded-lg ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function StatCard({ label, value, hint, accent = "orange", icon: Icon }) {
  const accents = {
    orange: "text-[#F97316]",
    blue: "text-[#2563EB]",
    green: "text-[#059669]",
    red: "text-[#DC2626]",
    yellow: "text-[#D97706]",
    purple: "text-[#7C3AED]",
  };
  return (
    <Card className="p-5">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-widest font-semibold text-zinc-500">{label}</div>
          <div className={`font-display font-bold text-3xl mt-1 num ${accents[accent] || ""}`}>{value}</div>
          {hint && <div className="text-xs text-zinc-500 mt-2">{hint}</div>}
        </div>
        {Icon && (
          <div className={`w-10 h-10 rounded-md bg-zinc-50 flex items-center justify-center ${accents[accent] || ""}`}>
            <Icon size={18} />
          </div>
        )}
      </div>
    </Card>
  );
}

export function EmptyState({ title = "Nothing here yet", desc = "", action = null, icon: Icon }) {
  return (
    <div className="flex flex-col items-center justify-center py-14 text-center">
      {Icon && (
        <div className="w-14 h-14 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-400 mb-4">
          <Icon size={26} />
        </div>
      )}
      <div className="font-display font-semibold text-lg">{title}</div>
      {desc && <div className="text-sm text-zinc-500 mt-1 max-w-md">{desc}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
